// Anklickbare Zeile in einer Liste (Prototyp Checklisten-Vorlagen): kleine Zeile oben, Name groß, Pfeil rechts.
import type { Icon } from '@phosphor-icons/react';
import { CaretRight } from '@phosphor-icons/react';
import { FELD, FORM } from './form-stil';

export function FormListenZeile({ titel, oben, icon: I, onClick, tip }: {
  titel: string;
  /** Kleine Zeile über dem Titel (Text aus dem Code) */
  oben?: string;
  icon?: Icon;
  onClick: () => void;
  tip?: string;
}) {
  return (
    <button type="button" onClick={onClick} data-tip={tip}
      className="pf-knopf flex w-full cursor-pointer flex-col border-none text-left"
      style={{ gap: 4, padding: '9px 13px 10px', borderRadius: FELD.radius, font: 'inherit', background: FELD.ruhe.flaeche, boxShadow: FELD.ruhe.ring }}>
      {oben && <span style={{ fontSize: 11, fontWeight: 700, color: FELD.ruhe.label }}>{oben}</span>}
      <span className="flex w-full items-center" style={{ gap: 8, minHeight: 24 }}>
        {I && <I aria-hidden size={14} weight="fill" color="rgba(255,255,255,0.5)" className="shrink-0" />}
        <span className="min-w-0 flex-1 truncate" style={{ fontSize: 15, fontWeight: 600, color: FORM.text }}>{titel}</span>
        <span aria-hidden className="flex shrink-0 items-center justify-center rounded-full" style={{ width: 24, height: 24, background: 'rgba(255,255,255,0.08)' }}>
          <CaretRight size={11} weight="bold" color="rgba(255,255,255,0.7)" />
        </span>
      </span>
    </button>
  );
}
